import { get } from 'lodash'

const change_offline_local_ids_name = {
  4: (state) => {
    const oldOfflineLocalIds = get(state, 'order.offlineLocalIds', [])

    return {
      ...state,
      order: {
        ...state.order,
        unsyncedLocalIds: oldOfflineLocalIds,
        offlineLocalIds: undefined,
      }
    }
  }
}

export default change_offline_local_ids_name
